<form [formGroup]="userForm">
  <div class="row">
    <mat-form-field class="col-6">
      <input
        matInput
        [formControlName]="'userid'"
        [placeholder]="'User ID'"
        [required]="true"
        (change)="checkUserId($event)"
      />
      @if (userForm.get('userid').hasError('required')) {
        <mat-error>This field is required</mat-error>
      }
      @if (userForm.get('userid').hasError('notUnique')) {
        <mat-error>This id already exists</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="col-6">
      <input
        matInput
        [formControlName]="'email'"
        [placeholder]="'Email'"
        [required]="true"
      />
      <mat-error>This field is required</mat-error>
    </mat-form-field> </div
  ><div class="row">
    <mat-form-field class="col-6">
      <input
        matInput
        [formControlName]="'firstName'"
        [placeholder]="'First Name'"
        [required]="true"
      />
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    <mat-form-field class="col-6">
      <input
        matInput
        [formControlName]="'lastName'"
        [placeholder]="'Last Name'"
        [required]="true"
      />
      <mat-error>This field is required</mat-error>
    </mat-form-field> </div
  ><div class="row">
    <span class="col-6">
      <mat-checkbox
        [formControlName]="'createrepcode'"
        [ngModel]="createRepcode"
        (change)="createRepcodeChanged($event)"
        >Create Repcode</mat-checkbox
      >
    </span>
    <mat-form-field class="col-6">
      <mat-label>Unit</mat-label>
      <input
        matInput
        placeholder="Unit"
        #unitInput
        [formControl]="userForm.get('unit')"
        (blur)="checkSelection()"
        [matAutocomplete]="autoUnit"
        [required]="userForm.get('createrepcode').value"
      />
      <mat-autocomplete #autoUnit="matAutocomplete">
        @if (unitDropdownLoading) {
          <mat-option disabled class="dropdownLoadingSpinner"
            ><mat-spinner diameter="48"></mat-spinner
          ></mat-option>
        }
        @if (unitDropdownNoResults) {
          <mat-option disabled>No Results</mat-option>
        }
        @if (!unitDropdownLoading && !unitDropdownNoResults) {
          @for (unit of filteredUnits; track $index) {
            <mat-option [value]="unit.id">
              {{ unit.id }}: {{ unit.name }}
            </mat-option>
          }
        }
      </mat-autocomplete>
      <mat-error>This field is required</mat-error>
    </mat-form-field> </div
  ><div class="row">
    <div class="col-6">
      <button mat-raised-button (click)="save()">Create User</button>
    </div>
    <div class="col-6">
      <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
  </div>
</form>
